export const PATHS = {
  home: '/',
  methodik: '/methodik',
  methodikDetail: (slug: string) => `/methodik/${slug}`,
  leistungen: '/leistungen',
  leistungenDetail: (slug: string) => `/leistungen/${slug}`,
  team: '/team',
  teamDetail: (slug: string) => `/team/${slug}`,
  aktuelles: '/aktuelles',
  aktuellesDetail: (slug: string) => `/aktuelles/${slug}`,
  kontakt: '/kontakt',
  impressum: '/impressum',
  datenschutz: '/datenschutz',
  widerruf: '/widerrufsbelehrung',
  en: '/en',
} as const;

export function isHomePath(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  return path === '/' || path === PATHS.en;
}
